'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cbDisclaimer = require('./cb-disclaimer.service');

var _cbDisclaimer2 = _interopRequireDefault(_cbDisclaimer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cbDisclaimerController($scope, cbDisclaimerService, $interpolate) {
    var _this = this;

    var vm = this;
    vm.jsonUrl = this.jsonUrl;
    vm.activeDisclaimer = this.activeDisclaimer;
    vm.warning = null;
    vm.disclaimer = null;

    try {
        vm.text = JSON.parse(this.textVars) || {};
    } catch (e) {
        vm.text = {};
    }

    vm.init = function () {
        if (_this.jsonUrl) {
            vm.parseData();
        }
    };

    vm.parseData = function () {
        cbDisclaimerService.getText(vm.jsonUrl).then(function (res) {
            if (!vm.activeDisclaimer) {
                vm.activeDisclaimer = 0;
            }

            // run interpolation to parse variables in the string
            vm.disclaimer = $interpolate(res.data.disclaimer[vm.activeDisclaimer])($scope);
        }).catch(function (err) {
            vm.warning = 'Kon niet de JSON ophalen met foutmelding ' + err + ' met de url ' + vm.jsonUrl;
        });
    };

    // Start init
    vm.init();
}

cbDisclaimerController.$inject = ['$scope', 'cbDisclaimerService', '$interpolate'];

exports.default = cbDisclaimerController;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/disclaimer/cb-disclaimer.controller.js
// module id = 883
// module chunks = 0